"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var block_ui_default_name_constant_1 = require("../../constants/block-ui-default-name.constant");
var BlockUIComponent = (function () {
    function BlockUIComponent() {
    }
    BlockUIComponent.prototype.ngOnInit = function () {
        this.name = this.name || block_ui_default_name_constant_1.BlockUIDefaultName;
    };
    BlockUIComponent.decorators = [
        { type: core_1.Component, args: [{
                    selector: 'block-ui',
                    template: "\n    <ng-content></ng-content>\n    <block-ui-content\n      [name]=\"name\"\n      [message]=\"message\"\n      [template]=\"template\"\n      [delayStart]=\"delayStart\"\n      [delayStop]=\"delayStop\"\n    >\n    </block-ui-content>\n  ",
                    encapsulation: core_1.ViewEncapsulation.None
                },] },
    ];
    /** @nocollapse */
    BlockUIComponent.ctorParameters = function () { return []; };
    BlockUIComponent.propDecorators = {
        'name': [{ type: core_1.Input },],
        'message': [{ type: core_1.Input },],
        'delayStart': [{ type: core_1.Input },],
        'delayStop': [{ type: core_1.Input },],
        'template': [{ type: core_1.Input },],
    };
    return BlockUIComponent;
}());
exports.BlockUIComponent = BlockUIComponent;



//////////////////
// WEBPACK FOOTER
// /var/jenkins_home/workspace/CLAIMS_PIPELINE/CLMTLK_UI_APP_PIPELINE/node_modules/ng-block-ui/dist/lib/components/block-ui/block-ui.component.js
// module id = jWVr
// module chunks = 3